// // Full updated SpotRegistration component with active pricing logic
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import App from "../../Utils/LayoutMobile";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import dayjs from "dayjs";

// const GST_RATE = 0.00;

// const SpotRegistration = () => {
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lName: "",
//     email: "",
//     whatsappNumber: "",
//     mobileNumber: "",
//     address: "",
//     prefix: "",
//   });

//   const [sessions, setSessions] = useState([]);
//   const [selectedSessions, setSelectedSessions] = useState([]);
//   const [subTotal, setSubTotal] = useState(0);
//   const [gstAmt, setGstAmt] = useState(0);
//   const [total, setTotal] = useState(0);
//   const [sameAsMobile, setSameAsMobile] = useState(false);

//   const getCurrentPriceCategory = (priceAndTime) => {
//     const now = new Date();
//     if (!Array.isArray(priceAndTime)) return null;

//     const sorted = priceAndTime
//       .filter((p) => p.date)
//       .sort((a, b) => new Date(a.date) - new Date(b.date));

//     for (let i = 0; i < sorted.length; i++) {
//       const priceDate = new Date(sorted[i].date);
//       if (now <= priceDate) {
//         return { ...sorted[i], index: i };
//       }
//     }

//     if (sorted.length > 0) {
//       return { ...sorted[sorted.length - 1], index: sorted.length - 1 };
//     }

//     return null;
//   };

//   useEffect(() => {
//     axios
//       .get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/conference/`)
//       .then((res) => setSessions(res.data.data || []))
//       .catch((err) => {
//         toast.error("Failed to load sessions.");
//         console.error(err);
//       });
//   }, []);

//   // const handleSessionToggle = (sessionId, sessionTitle, priceAndTime) => {
//   //   const active = getCurrentPriceCategory(priceAndTime);
//   //   const price = active?.price || 0;
//   //   const exists = selectedSessions.find((s) => s._id === sessionId);

//   //   const updated = exists
//   //     ? selectedSessions.filter((s) => s._id !== sessionId)
//   //     : [...selectedSessions, { _id: sessionId, title: sessionTitle, price }];

//   //   setSelectedSessions(updated);
//   // };
//   const handleSessionToggle = (sessionId, sessionTitle, priceAndTime) => {
//     const active = getCurrentPriceCategory(priceAndTime);
//     const price = active?.price || 0;
//     const exists = selectedSessions.find((s) => s._id === sessionId);

//     // Get the conferenceType of this session by checking against the sessions list
//     const matchedSession = sessions.find((e) => {
//       if (e._id === sessionId) return true;
//       if (e.info) return e.info.some((info) => info._id === sessionId);
//       return false;
//     });

//     const conferenceType = matchedSession?.conferenceType || "";

//     const updated = exists
//       ? selectedSessions.filter((s) => s._id !== sessionId)
//       : [
//           ...selectedSessions,
//           {
//             _id: sessionId,
//             title: sessionTitle,
//             price,
//             conferenceType, // ✅ include this
//               date: matchedSession?.date || new Date().toISOString(), 
//           },
//         ];

//     setSelectedSessions(updated);
//   };

//   useEffect(() => {
//     const subtotal = selectedSessions.reduce(
//       (acc, cur) => acc + Number(cur.price || 0),
//       0
//     );
//     const gst = subtotal * GST_RATE;
//     setSubTotal(subtotal);
//     setGstAmt(gst);
//     setTotal(subtotal + gst);
//   }, [selectedSessions]);

//   const conferenceTotal = selectedSessions
//     .filter((s) =>
//       sessions.some((e) => e.conferenceType === "conference" && e._id === s._id)
//     )
//     .reduce((acc, cur) => acc + Number(cur.price), 0);

//   const workshopTotal = selectedSessions
//     .filter((s) =>
//       sessions.some(
//         (e) =>
//           e.conferenceType === "workshop" &&
//           e.info?.some((i) => i._id === s._id)
//       )
//     )
//     .reduce((acc, cur) => acc + Number(cur.price), 0);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => {
//       const updated = { ...prev, [name]: value };

//       if (sameAsMobile && name === "mobileNumber") {
//         updated.whatsappNumber = value;
//       }

//       return updated;
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!formData.firstName.trim())
//       return toast.error("First Name is required");
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
//       return toast.error("Invalid Email");
//     if (!/^\d{10}$/.test(formData.mobileNumber))
//       return toast.error("Invalid Mobile number");
//     if (!/^\d{10}$/.test(formData.whatsappNumber))
//       return toast.error("Invalid WhatsApp number");
//     if (selectedSessions.length === 0)
//       return toast.error("Select at least one session");

//     const payload = {
//       ...formData,
//       RegistrationName: `${formData.firstName} ${formData.middleName || ""} ${
//         formData.lName || ""
//       }`.trim(),
//       RegistrationMobile: formData.mobileNumber,
//       selectedSessions,
//       totalPayable: total,
//       gstAmt,
//       subTotal,
//       paymentMode: "cod",
//     };

//     try {
//       // await axios.post(
//       //   "http://localhost:3500/api/v1/userRegistration/register/cod",
//       //   payload
//       // );
//       await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/api/v1/userRegistration/register/cod`,
//         payload
//       );
//       toast.success("Registered successfully via COD!");
//       setFormData({
//         firstName: "",
//         lName: "",
//         email: "",
//         whatsappNumber: "",
//         mobileNumber: "",
//         address: "",
//         prefix: "",
//       });
//       setSelectedSessions([]);
//       setSameAsMobile(false);
//     } catch (err) {
//       console.error(err);
//       toast.error("Registration failed.");
//     }
//   };

//   return (
//     <App>
//       <div className="container py-4">
//         <ToastContainer />
//         <h2 className="text-center mb-3">Spot Registration (COD)</h2>

//         {["conference", "workshop"].map((type) => {
//           const filteredEvents = sessions.filter(
//             (event) => event.conferenceType === type
//           );
//           if (filteredEvents.length === 0) return null;

//           return (
//             <div key={type} className="mb-5">
//               <h4
//                 className="fw-bold text-uppercase text-center mb-4"
//                 style={{ color: "#6f2c91" }}
//               >
//                 {type === "conference" ? "Conference" : "Workshop"}
//               </h4>

//               {filteredEvents.map((event) => {
//                 const isWorkshop = type === "workshop";

//                 return (
//                   <div key={event._id} className="mb-4">
//                     <div className="table-responsive">
//                       <table className="table table-bordered text-center align-middle">
//                         <thead
//                           style={{ backgroundColor: "#6f2c91", color: "white" }}
//                         >
//                           <tr>
//                             <th
//                               style={{
//                                 backgroundColor: "#6f2c91",
//                                 color: "white",
//                               }}
//                             >
//                               Select
//                             </th>
//                             <th
//                               style={{
//                                 backgroundColor: "#6f2c91",
//                                 color: "white",
//                               }}
//                             >
//                               {isWorkshop ? "Session Title" : "Event Title"}
//                             </th>
//                             <th
//                               style={{
//                                 backgroundColor: "#6f2c91",
//                                 color: "white",
//                               }}
//                             >
//                               Early Bird
//                               <br />
//                               <small>
//                                 (Till{" "}
//                                 {event.price_and_time?.[0]?.date
//                                   ? new Date(
//                                       event.price_and_time[0].date
//                                     ).toLocaleDateString("en-GB", {
//                                       day: "2-digit",
//                                       month: "short",
//                                       year: "numeric",
//                                     })
//                                   : ""}
//                                 )
//                               </small>
//                             </th>

//                             <th
//                               style={{
//                                 backgroundColor: "#6f2c91",
//                                 color: "white",
//                               }}
//                             >
//                               Timely
//                               <br />
//                               <small>
//                                 (Till{" "}
//                                 {event.price_and_time?.[1]?.date
//                                   ? new Date(
//                                       event.price_and_time[1].date
//                                     ).toLocaleDateString("en-GB", {
//                                       day: "2-digit",
//                                       month: "short",
//                                       year: "numeric",
//                                     })
//                                   : ""}
//                                 )
//                               </small>
//                             </th>

//                             <th
//                               style={{
//                                 backgroundColor: "#6f2c91",
//                                 color: "white",
//                               }}
//                             >
//                               Spot
//                               <br />
//                               <small>
//                                 (Till{" "}
//                                 {event.price_and_time?.[2]?.date
//                                   ? new Date(
//                                       event.price_and_time[2].date
//                                     ).toLocaleDateString("en-GB", {
//                                       day: "2-digit",
//                                       month: "short",
//                                       year: "numeric",
//                                     })
//                                   : ""}
//                                 )
//                               </small>
//                             </th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {/* Workshop Table (with sessions) */}
//                           {isWorkshop ? (
//                             <>
//                               {/* <tr
//                                 style={{
//                                   backgroundColor: "#f4e9ff",
//                                   fontWeight: "bold",
//                                 }}
//                               >
//                                 <td></td>
//                                 <td className="text-start">{event.title}</td>
//                                 {[0, 1, 2].map((i) => (
//                                   <td key={i}>
//                                     ₹ {event.price_and_time?.[i]?.price || 0}
//                                   </td>
//                                 ))}
//                               </tr> */}

//                               <tr
//                                 style={{
//                                   backgroundColor: "#f4e9ff",
//                                   fontWeight: "bold",
//                                 }}
//                               >
//                                 <td>
//                                   <input
//                                     type="checkbox"
//                                     className="form-check-input"
//                                     checked={event.info?.every((session) =>
//                                       selectedSessions.find(
//                                         (s) => s._id === session._id
//                                       )
//                                     )}
//                                     onChange={() => {
//                                       const allSelected = event.info?.every(
//                                         (session) =>
//                                           selectedSessions.find(
//                                             (s) => s._id === session._id
//                                           )
//                                       );

//                                       const updated = allSelected
//                                         ? selectedSessions.filter(
//                                             (s) =>
//                                               !event.info.some(
//                                                 (sess) => sess._id === s._id
//                                               )
//                                           )
//                                         : [
//                                             ...selectedSessions,
//                                             ...event.info
//                                               .filter(
//                                                 (session) =>
//                                                   !selectedSessions.find(
//                                                     (s) => s._id === session._id
//                                                   )
//                                               )
//                                               .map((session) => {
//                                                 const pricesWithDate =
//                                                   session.categoryPrices.map(
//                                                     (p) => ({
//                                                       ...p,
//                                                       date: event.price_and_time?.find(
//                                                         (d) =>
//                                                           d.title === p.category
//                                                       )?.date,
//                                                     })
//                                                   );
//                                                 const active =
//                                                   getCurrentPriceCategory(
//                                                     pricesWithDate
//                                                   );
//                                                 return {
//                                                   _id: session._id,
//                                                   title: session.title,
//                                                   price: active?.price || 0,
//                                                   conferenceType:
//                                                     event.conferenceType,
//                                                   // date: new Date().toISOString(),
//                                                     date:
//   Array.isArray(event.eventDate) && event.eventDate.length > 0
//     ? event.eventDate[0]
//     : event.date || new Date().toISOString(),

//                                                 };
//                                               }),
//                                           ];

//                                       setSelectedSessions(updated);
//                                     }}
//                                   />
//                                 </td>
//                                 <td className="text-start">
//                                   <strong>{event.title}</strong>
//                                 </td>
//                                 {["Early bird", "Timely", "Spot"].map(
//                                   (cat, i) => {
//                                     const categoryTotal = event.info?.reduce(
//                                       (acc, session) => {
//                                         const price =
//                                           session.categoryPrices.find(
//                                             (p) => p.category === cat
//                                           )?.price || 0;
//                                         return acc + Number(price);
//                                       },
//                                       0
//                                     );

//                                     const isActive =
//                                       getCurrentPriceCategory(
//                                         event.price_and_time
//                                       )?.category === cat;

//                                     return (
//                                       <td
//                                         key={i}
//                                         className={
//                                           isActive ? "fw-bold text-success" : ""
//                                         }
//                                         style={
//                                           !isActive
//                                             ? { color: "gray", opacity: 0.5 }
//                                             : {}
//                                         }
//                                       >
//                                         ₹ {categoryTotal}
//                                       </td>
//                                     );
//                                   }
//                                 )}
//                               </tr>

//                               {event.info?.map((session) => {
//                                 const pricesWithDate =
//                                   session.categoryPrices.map((p) => ({
//                                     ...p,
//                                     date: event.price_and_time?.find(
//                                       (d) => d.title === p.category
//                                     )?.date,
//                                   }));
//                                 const active =
//                                   getCurrentPriceCategory(pricesWithDate);
//                                 const isChecked = !!selectedSessions.find(
//                                   (s) => s._id === session._id
//                                 );

//                                 return (
//                                   <tr key={session._id}>
//                                     <td>
//                                       <input
//                                         type="checkbox"
//                                         className="form-check-input"
//                                         checked={isChecked}
//                                         onChange={() =>
//                                           handleSessionToggle(
//                                             session._id,
//                                             session.title,
//                                             pricesWithDate
//                                           )
//                                         }
//                                       />
//                                     </td>
//                                     <td className="text-start">
//                                       {session.title}
//                                     </td>
//                                     {["Early bird", "Timely", "Spot"].map(
//                                       (cat, i) => {
//                                         const priceObj =
//                                           session.categoryPrices.find(
//                                             (p) => p.category === cat
//                                           );
//                                         const isActive =
//                                           active?.category === cat;
//                                         return (
//                                           // <td
//                                           //   key={i}
//                                           //   className={
//                                           //     isActive
//                                           //       ? "fw-bold text-success"
//                                           //       : "text-muted text-decoration-line-through"
//                                           //   }
//                                           // >
//                                           //   ₹ {priceObj?.price || 0}
//                                           // </td>
//                                           <td
//                                             key={i}
//                                             className={
//                                               isActive
//                                                 ? "fw-bold text-success"
//                                                 : ""
//                                             }
//                                             style={
//                                               !isActive
//                                                 ? {
//                                                     color: "gray",
//                                                     opacity: 0.5,
//                                                   }
//                                                 : {}
//                                             }
//                                           >
//                                             ₹ {priceObj?.price || 0}
//                                           </td>
//                                         );
//                                       }
//                                     )}
//                                   </tr>
//                                 );
//                               })}
//                             </>
//                           ) : (
//                             // Conference Table (unchanged)
//                             // <tr>
//                             //   {(() => {
//                             //     const activeCategory = getCurrentPriceCategory(
//                             //       event.price_and_time
//                             //     );
//                             //     const isChecked = !!selectedSessions.find(
//                             //       (s) => s._id === event._id
//                             //     );
//                             //     return (
//                             //       <>
//                             //         <td>
//                             //           <input
//                             //             type="checkbox"
//                             //             className="form-check-input"
//                             //             checked={isChecked}
//                             //             onChange={() =>
//                             //               handleSessionToggle(
//                             //                 event._id,
//                             //                 event.title,
//                             //                 event.price_and_time
//                             //               )
//                             //             }
//                             //           />
//                             //         </td>
//                             //         <td className="text-start">
//                             //           <strong>{event.title}</strong>
//                             //         </td>
//                             //         {[0, 1, 2].map((i) => (
//                             //           // <td
//                             //           //   key={i}
//                             //           //   className={
//                             //           //     activeCategory?.index !== i
//                             //           //       ? "text-muted text-decoration-line-through"
//                             //           //       : "fw-bold text-success"
//                             //           //   }
//                             //           // >
//                             //           //   ₹{" "}
//                             //           //   {event.price_and_time?.[i]?.price ?? 0}
//                             //           // </td>
//                             //           <td
//                             //             key={i}
//                             //             className={
//                             //               activeCategory?.index === i
//                             //                 ? "fw-bold text-success"
//                             //                 : ""
//                             //             }
//                             //             style={
//                             //               activeCategory?.index === i
//                             //                 ? {}
//                             //                 : { color: "gray", opacity: 0.5 } // Gray & slightly transparent
//                             //             }
//                             //           >
//                             //             ₹{" "}
//                             //             {event.price_and_time?.[i]?.price ?? 0}
//                             //           </td>
//                             //         ))}
//                             //       </>
//                             //     );
//                             //   })()}
//                             // </tr>
//                             <tr>
//   {(() => {
//     const activeCategory = getCurrentPriceCategory(event.price_and_time);
//     const isChecked = !!selectedSessions.find((s) => s._id === event._id);

//     // Extract and format event date
//     const formattedDate = Array.isArray(event.eventDate)
//       ? `${dayjs(event.eventDate[0]).format("DD-MM-YYYY")} to ${dayjs(
//           event.eventDate[1]
//         ).format("DD-MM-YYYY")}`
//       : event.date
//       ? dayjs(event.date).format("DD-MM-YYYY")
//       : dayjs().format("DD-MM-YYYY");

//     return (
//       <>
//         <td>
//           <input
//             type="checkbox"
//             className="form-check-input"
//             checked={isChecked}
//             onChange={() =>
//               handleSessionToggle(
//                 event._id,
//                 event.title,
//                 event.price_and_time
//               )
//             }
//           />
//         </td>
//         <td className="text-start">
//           <strong>{event.title}</strong>
//         </td>
//         {/* <td>{formattedDate}</td> ✅ Event Date here */}
//         {[0, 1, 2].map((i) => (
//           <td
//             key={i}
//             className={
//               activeCategory?.index === i ? "fw-bold text-success" : ""
//             }
//             style={
//               activeCategory?.index === i
//                 ? {}
//                 : { color: "gray", opacity: 0.5 }
//             }
//           >
//             ₹ {event.price_and_time?.[i]?.price ?? 0}
//           </td>
//         ))}
//       </>
//     );
//   })()}
// </tr>

//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           );
//         })}

//         {/* Registration Form */}
//         <div
//           className="py-5"
//           style={{ backgroundColor: "#efe0ff", borderRadius: "25px" }}
//         >
//           <div className="container">
//             <h5 className="text-center fw-bold mb-4">CONTINUE REGISTRATION</h5>
//             <form onSubmit={handleSubmit}>
//               <div className="row g-3">
//                 <div className="col-md-4">
//                   <label className="form-label">Prefix</label>
//                   <select
//                     className="form-select"
//                     name="prefix"
//                     value={formData.prefix}
//                     onChange={handleInputChange}
//                   >
//                     <option value="">Prefix</option>
//                     <option value="Dr.">Dr.</option>
//                     <option value="Mr.">Mr.</option>
//                     <option value="Ms.">Ms.</option>
//                   </select>
//                 </div>

//                 <div className="col-md-4">
//                   <label className="form-label">Full Name *</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="firstName"
//                     placeholder="Enter your First name"
//                     value={formData.firstName}
//                     onChange={handleInputChange}
//                     required
//                   />
//                 </div>

//                 <div className="col-md-4">
//                   <label className="form-label">Qualification *</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="lName"
//                     placeholder="Enter your qualification"
//                     value={formData.lName}
//                     onChange={handleInputChange}
//                     required
//                   />
//                 </div>

//                 <div className="col-md-4">
//                   <label className="form-label">Email *</label>
//                   <input
//                     type="email"
//                     className="form-control"
//                     name="email"
//                     placeholder="Enter your email"
//                     value={formData.email}
//                     onChange={handleInputChange}
//                     required
//                   />
//                 </div>

//                 <div className="col-md-4">
//                   <label className="form-label">Mobile Number *</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="mobileNumber"
//                     placeholder="Enter your mobile number"
//                     value={formData.mobileNumber}
//                     onChange={handleInputChange}
//                     required
//                   />
//                   <div className="form-check mt-2">
//                     <input
//                       className="form-check-input"
//                       type="checkbox"
//                       id="sameAsMobile"
//                       checked={sameAsMobile}
//                       onChange={(e) => {
//                         const checked = e.target.checked;
//                         setSameAsMobile(checked);
//                         setFormData((prev) => ({
//                           ...prev,
//                           whatsappNumber: checked ? prev.mobileNumber : "",
//                         }));
//                       }}
//                     />
//                     <label className="form-check-label" htmlFor="sameAsMobile">
//                       Same as Mobile Number
//                     </label>
//                   </div>
//                 </div>

//                 <div className="col-md-4">
//                   <label className="form-label">WhatsApp Number *</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="whatsappNumber"
//                     placeholder="Enter your WhatsApp number"
//                     value={formData.whatsappNumber}
//                     onChange={handleInputChange}
//                     disabled={sameAsMobile}
//                     required
//                   />
//                 </div>
//               </div>

//               <hr className="my-4" style={{ borderTop: "2px solid #6e00ff" }} />

//               <div className="row">
//                 <div className="col-md-6"></div>
//                 <div className="col-md-6">
//                   <div
//                     className="p-4"
//                     style={{
//                       backgroundColor: "white",
//                       borderRadius: "20px",
//                       boxShadow: "0 0 10px rgba(0,0,0,0.05)",
//                       border: "1px solid #e2d4ff",
//                     }}
//                   >
//                     <h6
//                       className="fw-bold border-bottom pb-2"
//                       style={{ color: "#6e00ff" }}
//                     >
//                       Summary
//                     </h6>
//                     <div className="d-flex justify-content-between">
//                       <span>Conference Total</span>
//                       <span>₹ {conferenceTotal.toFixed(2)}</span>
//                     </div>
//                     <div className="d-flex justify-content-between">
//                       <span>Workshop Total</span>
//                       <span>₹ {workshopTotal.toFixed(2)}</span>
//                     </div>
//                     <div className="d-flex justify-content-between">
//                       <span>Subtotal</span>
//                       <span>₹ {subTotal.toFixed(2)}</span>
//                     </div>
//                     {/* <div className="d-flex justify-content-between">
//                       <span>GST (18%)</span>
//                       <span>₹ {gstAmt.toFixed(2)}</span>
//                     </div> */}
//                     <hr />
//                     <div className="d-flex justify-content-between fw-bold">
//                       <span>Final Payable</span>
//                       <span>₹ {total.toFixed(2)}</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="text-end mt-4">
//                 <button
//                   type="submit"
//                   className="btn px-4 py-2 rounded-pill"
//                   style={{ background: "#6f2c91", color: "white" }}
//                 >
//                   SUBMIT REGISTRATION
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </App>
//   );
// };

// export default SpotRegistration;
import React, { useState, useEffect } from "react";
import axios from "axios";
import App from "../../Utils/LayoutMobile";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";

const GST_RATE = 0.00;

const C_PINK   = "#F04DA0";
const C_PURPLE = "#8B2FC9";
const C_DARK   = "#1a0040";
const C_GRAD   = `linear-gradient(135deg, ${C_PINK}, ${C_PURPLE})`;

const SpotRegistration = () => {
  const [formData, setFormData] = useState({
    firstName: "", lName: "", email: "",
    whatsappNumber: "", mobileNumber: "", address: "", prefix: "",
  });
  const [sessions, setSessions]               = useState([]);
  const [selectedSessions, setSelectedSessions] = useState([]);
  const [subTotal, setSubTotal]               = useState(0);
  const [gstAmt, setGstAmt]                   = useState(0);
  const [total, setTotal]                     = useState(0);
  const [sameAsMobile, setSameAsMobile]       = useState(false);

  const getCurrentPriceCategory = (priceAndTime) => {
    const now = new Date();
    if (!Array.isArray(priceAndTime)) return null;
    const sorted = priceAndTime.filter(p => p.date).sort((a,b) => new Date(a.date)-new Date(b.date));
    for (let i=0;i<sorted.length;i++) {
      if (now <= new Date(sorted[i].date)) return { ...sorted[i], index: i };
    }
    return sorted.length > 0 ? { ...sorted[sorted.length-1], index: sorted.length-1 } : null;
  };

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/conference/`)
      .then(res => setSessions(res.data.data || []))
      .catch(() => toast.error("Failed to load sessions."));
  }, []);

  const handleSessionToggle = (sessionId, sessionTitle, priceAndTime) => {
    const active = getCurrentPriceCategory(priceAndTime);
    const price  = active?.price || 0;
    const exists = selectedSessions.find(s => s._id === sessionId);
    const matched = sessions.find(e => e._id === sessionId || e.info?.some(i => i._id === sessionId));
    const updated = exists
      ? selectedSessions.filter(s => s._id !== sessionId)
      : [...selectedSessions, { _id: sessionId, title: sessionTitle, price, conferenceType: matched?.conferenceType || "", date: matched?.date || new Date().toISOString() }];
    setSelectedSessions(updated);
  };

  useEffect(() => {
    const sub = selectedSessions.reduce((a,c) => a + Number(c.price||0), 0);
    const gst = sub * GST_RATE;
    setSubTotal(sub); setGstAmt(gst); setTotal(sub+gst);
  }, [selectedSessions]);

  const conferenceTotal = selectedSessions
    .filter(s => sessions.some(e => e.conferenceType==="conference" && e._id===s._id))
    .reduce((a,c) => a+Number(c.price), 0);
  const workshopTotal = selectedSessions
    .filter(s => sessions.some(e => e.conferenceType==="workshop" && e.info?.some(i => i._id===s._id)))
    .reduce((a,c) => a+Number(c.price), 0);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const updated = { ...prev, [name]: value };
      if (sameAsMobile && name==="mobileNumber") updated.whatsappNumber = value;
      return updated;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.firstName.trim())                          return toast.error("First Name is required");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) return toast.error("Invalid Email");
    if (!/^\d{10}$/.test(formData.mobileNumber))             return toast.error("Invalid Mobile number");
    if (!/^\d{10}$/.test(formData.whatsappNumber))           return toast.error("Invalid WhatsApp number");
    if (selectedSessions.length === 0)                       return toast.error("Select at least one session");

    const payload = {
      ...formData,
      RegistrationName: `${formData.firstName} ${formData.lName||""}`.trim(),
      RegistrationMobile: formData.mobileNumber,
      selectedSessions, totalPayable: total, gstAmt, subTotal, paymentMode: "cod",
    };
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/userRegistration/register/cod`, payload);
      toast.success("Registered successfully!");
      setFormData({ firstName:"",lName:"",email:"",whatsappNumber:"",mobileNumber:"",address:"",prefix:"" });
      setSelectedSessions([]); setSameAsMobile(false);
    } catch { toast.error("Registration failed."); }
  };

  /* ─── Price label helpers ─── */
  const PRICE_LABELS = ["Early Bird", "Timely", "Spot"];

  return (
    <App>
      <div className="sr-page">
        <ToastContainer position="top-right" autoClose={3000} />

        {/* ── Page header ── */}
        <div className="sr-page-header">
          <div className="sr-eyebrow">
            <span className="sr-eyebrow-dot" />
            Admin Panel
          </div>
          <h1 className="sr-page-title">Spot Registration <span className="sr-grad">COD</span></h1>
          <p className="sr-page-sub">Register delegates on the spot with cash on delivery payment.</p>
        </div>

        {/* ══ SESSION SELECTION ══ */}
        {["conference","workshop"].map(type => {
          const events = sessions.filter(e => e.conferenceType === type);
          if (!events.length) return null;
          const Icon = type === "conference"
            ? <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
            : <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M14.5 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/></svg>;

          return (
            <div key={type} className="sr-section">
              <div className="sr-section-header">
                <span className="sr-section-icon" style={{color: type==="conference"?C_PINK:C_PURPLE, background: type==="conference"?"rgba(240,77,160,0.1)":"rgba(139,47,201,0.1)", borderColor: type==="conference"?"rgba(240,77,160,0.2)":"rgba(139,47,201,0.2)"}}>
                  {Icon}
                </span>
                <div>
                  <h2 className="sr-section-title">{type === "conference" ? "Conference Sessions" : "Workshop Sessions"}</h2>
                  <p className="sr-section-sub">{events.length} {events.length===1?"event":"events"} available</p>
                </div>
              </div>

              {events.map(event => {
                const isWorkshop = type === "workshop";
                return (
                  <div key={event._id} className="sr-table-card">
                    {/* Table header */}
                    <div className="sr-table-title">
                      <span style={{fontWeight:700,color:C_DARK,fontSize:14}}>{event.title}</span>
                    </div>

                    <div className="sr-table-wrap">
                      <table className="sr-table">
                        <thead>
                          <tr>
                            <th style={{width:52}}>Select</th>
                            <th>{isWorkshop ? "Session Title" : "Event Title"}</th>
                            {PRICE_LABELS.map((lbl,i) => (
                              <th key={i}>
                                {lbl}
                                {event.price_and_time?.[i]?.date && (
                                  <span className="sr-th-date">
                                    Till {new Date(event.price_and_time[i].date).toLocaleDateString("en-GB",{day:"2-digit",month:"short",year:"numeric"})}
                                  </span>
                                )}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {isWorkshop ? (
                            <>
                              {/* Workshop parent row */}
                              <tr className="sr-tr-parent">
                                <td>
                                  <input type="checkbox" className="sr-checkbox"
                                    checked={event.info?.every(s => selectedSessions.find(x => x._id===s._id))}
                                    onChange={() => {
                                      const allSel = event.info?.every(s => selectedSessions.find(x => x._id===s._id));
                                      const updated = allSel
                                        ? selectedSessions.filter(s => !event.info.some(sess => sess._id===s._id))
                                        : [...selectedSessions, ...event.info.filter(s => !selectedSessions.find(x => x._id===s._id)).map(session => {
                                            const pwt = session.categoryPrices.map(p => ({...p, date: event.price_and_time?.find(d => d.title===p.category)?.date}));
                                            const active = getCurrentPriceCategory(pwt);
                                            return { _id:session._id, title:session.title, price:active?.price||0, conferenceType:event.conferenceType,
                                              date: Array.isArray(event.eventDate)&&event.eventDate.length>0 ? event.eventDate[0] : event.date||new Date().toISOString() };
                                          })];
                                      setSelectedSessions(updated);
                                    }}
                                  />
                                </td>
                                <td><strong>{event.title}</strong></td>
                                {["Early bird","Timely","Spot"].map((cat,i) => {
                                  const catTotal = event.info?.reduce((a,s) => a + Number(s.categoryPrices.find(p=>p.category===cat)?.price||0),0);
                                  const isActive = getCurrentPriceCategory(event.price_and_time)?.category===cat;
                                  return (
                                    <td key={i} className={isActive?"sr-price-active":"sr-price-inactive"}>
                                      {isActive && <span className="sr-active-dot"/>}
                                      ₹{catTotal}
                                    </td>
                                  );
                                })}
                              </tr>
                              {/* Workshop child rows */}
                              {event.info?.map(session => {
                                const pwt = session.categoryPrices.map(p => ({...p, date: event.price_and_time?.find(d => d.title===p.category)?.date}));
                                const active = getCurrentPriceCategory(pwt);
                                const isChecked = !!selectedSessions.find(s => s._id===session._id);
                                return (
                                  <tr key={session._id} className={isChecked?"sr-tr-selected":""}>
                                    <td>
                                      <input type="checkbox" className="sr-checkbox" checked={isChecked}
                                        onChange={() => handleSessionToggle(session._id, session.title, pwt)}/>
                                    </td>
                                    <td className="sr-td-indent">↳ {session.title}</td>
                                    {["Early bird","Timely","Spot"].map((cat,i) => {
                                      const priceObj = session.categoryPrices.find(p=>p.category===cat);
                                      const isActive = active?.category===cat;
                                      return (
                                        <td key={i} className={isActive?"sr-price-active":"sr-price-inactive"}>
                                          {isActive&&<span className="sr-active-dot"/>}₹{priceObj?.price||0}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                );
                              })}
                            </>
                          ) : (
                            // Conference row
                            (() => {
                              const activeCategory = getCurrentPriceCategory(event.price_and_time);
                              const isChecked = !!selectedSessions.find(s => s._id===event._id);
                              return (
                                <tr className={isChecked?"sr-tr-selected":""}>
                                  <td>
                                    <input type="checkbox" className="sr-checkbox" checked={isChecked}
                                      onChange={() => handleSessionToggle(event._id, event.title, event.price_and_time)}/>
                                  </td>
                                  <td><strong>{event.title}</strong></td>
                                  {[0,1,2].map(i => {
                                    const isActive = activeCategory?.index===i;
                                    return (
                                      <td key={i} className={isActive?"sr-price-active":"sr-price-inactive"}>
                                        {isActive&&<span className="sr-active-dot"/>}₹{event.price_and_time?.[i]?.price??0}
                                      </td>
                                    );
                                  })}
                                </tr>
                              );
                            })()
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}

        {/* ══ REGISTRATION FORM ══ */}
        <div className="sr-form-card">

          <div className="sr-form-header">
            <span className="sr-section-icon" style={{color:C_PINK,background:"rgba(240,77,160,0.1)",borderColor:"rgba(240,77,160,0.2)"}}>
              <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
              </svg>
            </span>
            <div>
              <h2 className="sr-section-title">Delegate Information</h2>
              <p className="sr-section-sub">Fill in the registration details below</p>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="sr-form-grid">

              <div className="sr-field">
                <label className="sr-label">Prefix</label>
                <select className="sr-input" name="prefix" value={formData.prefix} onChange={handleInputChange}>
                  <option value="">Select prefix</option>
                  <option>Dr.</option><option>Mr.</option><option>Ms.</option>
                </select>
              </div>

              <div className="sr-field">
                <label className="sr-label">Full Name <span className="sr-required">*</span></label>
                <input className="sr-input" type="text" name="firstName" placeholder="Enter full name"
                  value={formData.firstName} onChange={handleInputChange} required/>
              </div>

              <div className="sr-field">
                <label className="sr-label">Qualification <span className="sr-required">*</span></label>
                <input className="sr-input" type="text" name="lName" placeholder="e.g. MBBS, MD"
                  value={formData.lName} onChange={handleInputChange} required/>
              </div>

              <div className="sr-field">
                <label className="sr-label">Email Address <span className="sr-required">*</span></label>
                <input className="sr-input" type="email" name="email" placeholder="email@example.com"
                  value={formData.email} onChange={handleInputChange} required/>
              </div>

              <div className="sr-field">
                <label className="sr-label">Mobile Number <span className="sr-required">*</span></label>
                <input className="sr-input" type="text" name="mobileNumber" placeholder="10-digit mobile"
                  value={formData.mobileNumber} onChange={handleInputChange} required/>
                <label className="sr-checkbox-label">
                  <input type="checkbox" className="sr-checkbox" id="sameAsMobile" checked={sameAsMobile}
                    onChange={e => { setSameAsMobile(e.target.checked); setFormData(p => ({...p, whatsappNumber: e.target.checked ? p.mobileNumber : ""})); }}/>
                  Same as Mobile Number
                </label>
              </div>

              <div className="sr-field">
                <label className="sr-label">WhatsApp Number <span className="sr-required">*</span></label>
                <input className="sr-input" type="text" name="whatsappNumber" placeholder="10-digit WhatsApp"
                  value={formData.whatsappNumber} onChange={handleInputChange} disabled={sameAsMobile} required/>
              </div>

            </div>

            {/* ── Summary + Submit ── */}
            <div className="sr-bottom-row">
              <div className="sr-summary">
                <div className="sr-summary-title">
                  <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                  </svg>
                  Order Summary
                </div>
                <div className="sr-summary-rows">
                  <div className="sr-summary-row">
                    <span>Conference Total</span>
                    <span>₹{conferenceTotal.toFixed(2)}</span>
                  </div>
                  <div className="sr-summary-row">
                    <span>Workshop Total</span>
                    <span>₹{workshopTotal.toFixed(2)}</span>
                  </div>
                  <div className="sr-summary-row">
                    <span>Subtotal</span>
                    <span>₹{subTotal.toFixed(2)}</span>
                  </div>
                  <div className="sr-summary-divider"/>
                  <div className="sr-summary-row sr-summary-total">
                    <span>Final Payable</span>
                    <span className="sr-total-val">₹{total.toFixed(2)}</span>
                  </div>
                </div>
              </div>

              <div className="sr-submit-wrap">
                <div className="sr-selected-count">
                  <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  {selectedSessions.length} session{selectedSessions.length!==1?"s":""} selected
                </div>
                <button type="submit" className="sr-submit-btn">
                  <span>Submit Registration</span>
                  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </button>
              </div>
            </div>
          </form>
        </div>

      </div>

      <style>{`
        @keyframes sr-fadeUp {
          from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)}
        }
        @keyframes sr-pulse {
          0%,100%{opacity:1}50%{opacity:0.35}
        }

        *,*::before,*::after{box-sizing:border-box}

        .sr-page {
          background:#f4eefa;min-height:100vh;
          padding:28px 32px 60px;
          display:flex;flex-direction:column;gap:28px;
          font-family:inherit;
        }

        /* ── Page header ── */
        .sr-page-header { animation:sr-fadeUp .4s ease both; }
        .sr-eyebrow {
          display:inline-flex;align-items:center;gap:7px;
          font-size:11px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;
          color:${C_PINK};background:rgba(240,77,160,0.08);
          border:1px solid rgba(240,77,160,0.2);
          padding:5px 14px 5px 10px;border-radius:50px;margin-bottom:12px;
        }
        .sr-eyebrow-dot {
          width:6px;height:6px;border-radius:50%;background:${C_PINK};
          animation:sr-pulse 2s infinite;flex-shrink:0;
        }
        .sr-page-title {
          font-size:clamp(22px,2.5vw,30px);font-weight:800;color:${C_DARK};
          letter-spacing:-.025em;margin:0 0 6px;
        }
        .sr-grad {
          background:linear-gradient(90deg,${C_PINK},#c066f0);
          -webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;
        }
        .sr-page-sub { font-size:13.5px;color:#8a7a9a;margin:0; }

        /* ── Section ── */
        .sr-section { display:flex;flex-direction:column;gap:16px;animation:sr-fadeUp .4s ease .05s both; }
        .sr-section-header { display:flex;align-items:center;gap:13px; }
        .sr-section-icon {
          width:42px;height:42px;border-radius:11px;flex-shrink:0;
          display:flex;align-items:center;justify-content:center;
          border:1px solid;
        }
        .sr-section-title { font-size:17px;font-weight:800;color:${C_DARK};margin:0; }
        .sr-section-sub   { font-size:12px;color:#9a86b8;margin:3px 0 0; }

        /* ── Table card ── */
        .sr-table-card {
          background:#fff;border-radius:18px;
          border:1px solid #ede5f5;
          box-shadow:0 4px 20px rgba(26,0,64,.06);
          overflow:hidden;
        }
        .sr-table-title {
          padding:14px 20px;
          border-bottom:1px solid #f3ecfa;
          background:#faf6fe;
        }
        .sr-table-wrap { overflow-x:auto; }

        /* ── Table ── */
        .sr-table { width:100%;border-collapse:collapse;font-size:13px; }
        .sr-table thead tr { background:#faf5ff; }
        .sr-table th {
          padding:12px 16px;text-align:left;
          font-size:11px;font-weight:800;letter-spacing:.07em;text-transform:uppercase;
          color:#8a70a8;white-space:nowrap;border-bottom:2px solid #f0e8f8;
        }
        .sr-th-date {
          display:block;font-size:9.5px;font-weight:600;color:#b0a0c8;
          text-transform:none;letter-spacing:.03em;margin-top:2px;
        }
        .sr-table td { padding:13px 16px;border-top:1px solid #f5f0fa;vertical-align:middle; }
        .sr-table tbody tr:hover td { background:#fdf8ff; }

        .sr-tr-parent td { background:#faf5ff;font-weight:700; }
        .sr-tr-selected td { background:rgba(240,77,160,0.04); }

        .sr-td-indent { color:#6a5a7a;padding-left:28px !important;font-size:12.5px; }

        /* Prices */
        .sr-price-active {
          font-weight:800;color:#16a34a !important;
          display:flex;align-items:center;gap:5px;
        }
        .sr-price-inactive { color:#c0b0d0 !important;font-size:12.5px; }
        .sr-active-dot {
          width:6px;height:6px;border-radius:50%;
          background:#16a34a;flex-shrink:0;display:inline-block;
        }

        /* Checkbox */
        .sr-checkbox {
          width:16px;height:16px;border-radius:4px;
          border:1.5px solid #d0c0e0;cursor:pointer;
          accent-color:${C_PINK};
        }

        /* ── Form card ── */
        .sr-form-card {
          background:#fff;border-radius:20px;
          border:1px solid #ede5f5;
          box-shadow:0 4px 20px rgba(26,0,64,.06);
          overflow:hidden;
          animation:sr-fadeUp .4s ease .1s both;
        }
        .sr-form-header {
          display:flex;align-items:center;gap:13px;
          padding:20px 24px 18px;
          border-bottom:1px solid #f3ecfa;
          background:#faf6fe;
        }

        /* Form grid */
        .sr-form-grid {
          display:grid;grid-template-columns:repeat(3,1fr);gap:20px;
          padding:24px 24px 0;
        }
        .sr-field { display:flex;flex-direction:column;gap:6px; }
        .sr-label { font-size:12px;font-weight:700;color:#5a5070;letter-spacing:.03em; }
        .sr-required { color:${C_PINK}; }
        .sr-input {
          height:42px;border-radius:10px;
          border:1.5px solid #e8d8f8;
          padding:0 14px;font-size:13.5px;color:${C_DARK};
          background:#fdfbff;
          transition:border-color .2s,box-shadow .2s;outline:none;
          font-family:inherit;
        }
        .sr-input:focus {
          border-color:${C_PINK};
          box-shadow:0 0 0 3px rgba(240,77,160,0.12);
          background:#fff;
        }
        .sr-input:disabled { background:#f5f0fa;color:#9a86b8;cursor:not-allowed; }
        select.sr-input { cursor:pointer; }
        .sr-checkbox-label {
          display:inline-flex;align-items:center;gap:6px;
          font-size:12px;font-weight:600;color:#7a6a8a;
          margin-top:6px;cursor:pointer;
        }

        /* ── Bottom row ── */
        .sr-bottom-row {
          display:grid;grid-template-columns:1fr 1fr;gap:24px;
          padding:24px;align-items:end;
          border-top:1px solid #f3ecfa;
          margin-top:24px;
        }

        /* Summary */
        .sr-summary {
          background:#faf5ff;border-radius:16px;
          border:1px solid #ede5f5;padding:18px 20px;
        }
        .sr-summary-title {
          display:flex;align-items:center;gap:7px;
          font-size:12px;font-weight:800;color:${C_PURPLE};
          text-transform:uppercase;letter-spacing:.07em;margin-bottom:14px;
        }
        .sr-summary-rows { display:flex;flex-direction:column;gap:8px; }
        .sr-summary-row {
          display:flex;justify-content:space-between;align-items:center;
          font-size:13px;color:#6a5a7a;
        }
        .sr-summary-divider { height:1px;background:#ede5f5;margin:4px 0; }
        .sr-summary-total { font-weight:700;color:${C_DARK};font-size:14px; }
        .sr-total-val {
          font-size:18px;font-weight:800;
          background:linear-gradient(135deg,${C_PINK},${C_PURPLE});
          -webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;
        }

        /* Submit */
        .sr-submit-wrap { display:flex;flex-direction:column;align-items:flex-end;gap:12px; }
        .sr-selected-count {
          display:inline-flex;align-items:center;gap:6px;
          font-size:12.5px;font-weight:700;color:#16a34a;
          background:#f0fdf4;border:1px solid #bbf7d0;
          padding:6px 14px;border-radius:8px;
        }
        .sr-submit-btn {
          display:inline-flex;align-items:center;gap:10px;
          padding:13px 32px;
          background:${C_GRAD};
          color:#fff;font-size:14.5px;font-weight:700;
          border:none;border-radius:12px;cursor:pointer;
          box-shadow:0 8px 24px rgba(240,77,160,0.3);
          transition:transform .25s cubic-bezier(.16,1,.3,1),box-shadow .25s;
          letter-spacing:.02em;font-family:inherit;
          position:relative;overflow:hidden;
        }
        .sr-submit-btn::before {
          content:"";position:absolute;inset:0;
          background:linear-gradient(135deg,${C_PURPLE},${C_PINK});
          opacity:0;transition:opacity .3s;
        }
        .sr-submit-btn:hover { transform:translateY(-2px);box-shadow:0 14px 32px rgba(240,77,160,0.42); }
        .sr-submit-btn:hover::before { opacity:1; }
        .sr-submit-btn span,.sr-submit-btn svg { position:relative;z-index:1; }

        /* Responsive */
        @media(max-width:1024px){ .sr-form-grid{grid-template-columns:repeat(2,1fr)} }
        @media(max-width:768px){
          .sr-page{padding:18px 16px 48px;gap:20px}
          .sr-form-grid{grid-template-columns:1fr}
          .sr-bottom-row{grid-template-columns:1fr}
          .sr-submit-wrap{align-items:stretch}
          .sr-submit-btn{justify-content:center}
        }
      `}</style>
    </App>
  );
};

export default SpotRegistration;